export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const REQUEST_TIMEOUT = 5;
export const RECIPES_PER_PAGE = 10;
export const API_KEY = '73e71935-79e4-41b7-aa4a-2de4defe2cb3';
